// extracted by mini-css-extract-plugin
export default {"badge":"ServiceBadge_badge__Ww1t7","mostPopularBadge":"ServiceBadge_mostPopularBadge__ifqP1","newsBadge":"ServiceBadge_newsBadge__p0Zq5","showBadge":"ServiceBadge_showBadge__Mm87C"};